import React from 'react';
import Prompt from './Prompt';
import Popup from './Popup';
import PropTypes from 'prop-types';
import SurveyIcon from '../SurveyIcon';

class TimedQuestionWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isImgLoaded: false,
      isOpen: false,
      showButton: false
    };
  }

  componentDidMount() {
    const url = window.location.href;
    let undoAutoPlay = false;

    if(url.includes('edit') || url.includes('overview')) {
      undoAutoPlay = true;
      this.setState({
        showButton: true
      });
    }
    
    if (this.props.auto_play && !undoAutoPlay) {
      setTimeout(() => {this.open()}, 5000);
    }
  }

  startTimer() {
    if(this.state.isOpen) {
      setTimeout(() => { 
        this.setState({isOpen: false});
        document.querySelector('button[type="submit"]').click();
      }, this.props.number_of_seconds * 1000 + 2500);
    }
  }

  open() {
    this.setState({
      isOpen: true,
      promptBbox: this.prompt && this.prompt.getBoundingClientRect(),
    }, ()  => {this.startTimer()});
    if (this.props.onOpen) {
      this.props.onOpen();
    }
  }

  close() {
    this.setState({
      isOpen: false,
    });
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  onImgLoad() {
    this.setState({
      isImgLoaded: true,
    });
  }

  getImgRef(node) {
    this.zoomedImg = node;
  }

  render() {
    const { id, url, thumbUrl,dimensions} = this.props;
    const { isImgLoaded, isOpen, promptBbox } = this.state;
    const { large } = dimensions;
    const { width, height } = large ? large : {};
    
    return (
      <div>
        <Prompt
          isImgLoaded={isImgLoaded}
          isTargetOpen={isOpen && isImgLoaded}
          onClick={this.open.bind(this)}
          promptBbox={promptBbox}
          zoomedImg={this.zoomedImg}
          autoPlay={this.props.auto_play}
          showButton={this.state.showButton}
        >
          <img
            alt="Timed question"
            crossOrigin="Anonymous"
            style={{filter: "blur(8px)"}}
            src={thumbUrl}
            width={width}
            height={height}
            ref={node => (this.prompt = node)}
          />
          <div style={{position: "absolute", inset: "0px", background: "rgba(0, 0, 0, 1.5)"}}></div>
        </Prompt>
        <Popup
          dimensions={dimensions}
          getImgRef={this.getImgRef.bind(this)}
          id={id}
          isOpen={isOpen && isImgLoaded}
          onCloseClick={this.close.bind(this)}
          promptBbox={promptBbox}
          url={url}
        >
          { this.state.showButton ? (
            <div style={{ height: "30px", width: "100%" }}>
              <button
                className="btn btn-icon btn-large btn-stealth mb0 grow-0 shrink-1 c-white hover-white hover-bg-trans pos-a btn-ff-base"
                onClick={this.close.bind(this)}
                type="button"
                style={{ position: "absolute", right: "10px", top: "-20px" }}
              >
                <SurveyIcon icon="x" width="18" height="18" />
              </button>
            </div>
          ) : null}
          
        </Popup>

        {/* preload the full image */}
        <img
          alt=""
          crossOrigin="Anonymous"
          src={url}
          style={{
            position: 'absolute',
            zIndex: '-1',
            visibility: 'hidden',
            left: '-9999px',
            bottom: '0',
          }}
          onLoad={this.onImgLoad.bind(this)}
        />
      </div>
    );
  }
}
TimedQuestionWidget.propTypes = {
  dimensions: PropTypes.object,
  id: PropTypes.string,
  number_of_seconds: PropTypes.number,
  onCloseClick: PropTypes.func,
  setDomain: PropTypes.func,
  thumbUrl: PropTypes.string,
  auto_play: PropTypes.bool,
  url: PropTypes.string.isRequired,
};

export default TimedQuestionWidget;
